import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tabsRoot: {
    backgroundColor: 'unset'
  },
  overviewTab: {
    '&&': {
      overflow: 'visible',
      height: 'auto'
    }
  }
}));
